// @flow
import React, { useState, useEffect } from 'react';
import type { Node } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import DoubleInput from './DoubleInput';


const useStyles = makeStyles({
    root: {
        minWidth: 250,
        flexDirection: 'row'
    },
    input: {
        minWidth: 125,
        maxWidth: '50%'
    }
});

type Props = $ReadOnly<{
    type: 'text' | 'number',
    label: Node,
    path: $ReadOnlyArray<string>,
    value: boolean,
    defaultValue?: string | number,
    placeholder?: string,
    prepend?: Node,
    append?: Node,

    onChange: (path: $ReadOnlyArray<string>, value: boolean) => void,
    inputFormatter?: (value: any) => number | string
}>;

function Coordinate({ label, path, value, defaultValue, placeholder, prepend, append, onChange, inputFormatter }: Props) {
    const classes = useStyles();
    const [innerValue, setInnerValue] = useState(typeof value !== 'undefined' && inputFormatter ? inputFormatter(value) : value);

    useEffect(() => setInnerValue(typeof value !== 'undefined' && inputFormatter ? inputFormatter(value) : value), [value, inputFormatter]);

    const handleChange = (e) => setInnerValue(e.target.value);
    const handleBlur = () => {
        const x = parseFloat(innerValue.x);
        const y = parseFloat(innerValue.y);

        if(!isNaN(x) || !isNaN(y)) {
            const newValue = {};

            if(!isNaN(x)) {
                newValue.x = x;
            }
            if(!isNaN(y)) {
                newValue.y = y;
            }

            onChange(path, newValue);
        }
    };

    return (
        <TextField
            className={classes.root}
            label={label}
            margin="dense"
            variant="filled"
            value={typeof innerValue !== 'undefined' ? innerValue : ( (typeof defaultValue !== 'undefined' && inputFormatter ? inputFormatter(defaultValue) : defaultValue ) || [])}
            placeholder={placeholder}
            InputProps={{
                inputComponent: DoubleInput,
                startAdornment: prepend && <InputAdornment position="start">{prepend}</InputAdornment>,
                endAdornment: append && <InputAdornment position="end">{append}</InputAdornment>
            }}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
}

export default Coordinate;